export const UAM_GRANULAR_PERMISSIONS = 'uam-granular-permissions';
export const FULL_PAN_VIEW = 'full-pan-view';
